module.exports = __webpack_public_path__ + "static/img/img44.892ecb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img44.png
// module id = nHv9
// module chunks = 1